import cartReducer from './reservation';
import eventsReducer from './events';
import membershipReducer from './membership';

const reducer = {
  cart: cartReducer,
  events: eventsReducer,
  membership: membershipReducer,
};

export default reducer;
